import { status as Status } from '@bt-react/constants'
import { drawerType } from '@bt-react/constants'
import { SettingsTabs } from '../../../components/SettingsModal/types'

export interface UIReducer {
  actionsMenuOpen: boolean
  forcedLocalMute: boolean
  goingLive: boolean
  hideItsTime: boolean
  isCamHidden: Map<string, boolean>
  isDeadMansHandleOpen: boolean
  isEndRequested: boolean
  isLive: boolean
  isLiveReady: boolean
  isLiveRequested: boolean
  isModalOpen: boolean
  isMuted: Map<string, boolean>
  isPreRoll: boolean
  isSidePanelOpen: boolean
  isTerminated: boolean
  isUpcoming: boolean
  liveDateTime: string | null
  menuItemSelected: string
  messageCode: string | null
  slides: any[]
  selectedDrawer: drawerType | null
  showInterstitial: boolean
  showLiveEnabledModal: boolean
  showMediaDrawer: boolean
  showPlayInModal: boolean
  showRescheduledModal: boolean
  showSettingsModal: boolean
  showStreamModal: boolean
  showSlidesUploadModal: boolean
  showGigStartConfirmationModal: boolean
  showGigEndConfirmationModal: boolean
  status: Status | null
  twilioConnectionError: string | null
  settingsModalTab: SettingsTabs | null
  focused: boolean
}

export const defaultState: UIReducer = {
  actionsMenuOpen: true,
  forcedLocalMute: false,
  goingLive: false,
  hideItsTime: false,
  isCamHidden: new Map(),
  isDeadMansHandleOpen: false,
  isEndRequested: false,
  isLive: false,
  isLiveReady: false,
  isLiveRequested: false,
  isModalOpen: false,
  isMuted: new Map(),
  isPreRoll: true,
  isSidePanelOpen: false,
  isTerminated: false,
  isUpcoming: true,
  liveDateTime: null,
  menuItemSelected: 'details',
  messageCode: null,
  slides: [],
  selectedDrawer: null,
  showInterstitial: false,
  showLiveEnabledModal: false,
  showMediaDrawer: false,
  showPlayInModal: false,
  showRescheduledModal: false,
  showSettingsModal: false,
  showSlidesUploadModal: false,
  showStreamModal: false,
  showGigStartConfirmationModal: false,
  showGigEndConfirmationModal: false,
  status: null,
  twilioConnectionError: null,
  settingsModalTab: null,
  focused: true
}

export default defaultState
